import React, { useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import ResidentProfileHeader from '@components/resident-notes/ResidentProfileHeader';
import AddComment from '@components/resident-notes/AddComment';
import CommentList from '@components/resident-notes/CommentList';
import CaseNotes from '@components/resident-notes/CaseNotes';
import PrognosisSection from '@components/resident-notes/prognosis-section';

const PatientNotes: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [refreshComments, setRefreshComments] = useState<boolean>(false);
  const [fullName, setFullName] = useState('');
  const [prognosisFromData, setPrognosisFromData] = useState('');
  const [isUpdatedPronosis, setIsUpdatedPrognosis] = useState(false);

  const handleRefreshComments = () => {
    setRefreshComments(!refreshComments);
  };
  const pigRef = useRef<HTMLDivElement>(null);

  const scrollToPrognosis = () => {
    pigRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <div className="govuk-width-container mt-5">
      <ResidentProfileHeader
        slug={slug}
        setFullName={setFullName}
        setPrognosisFromData={setPrognosisFromData}
        isUpdatedPronosis={isUpdatedPronosis}
        scrollToPrognosis={scrollToPrognosis}
      />

      <PrognosisSection
        fullName={fullName}
        prognosisFromData={prognosisFromData}
        slug={slug}
        isUpdatedPronosis={isUpdatedPronosis}
        setIsUpdatedPrognosis={setIsUpdatedPrognosis}
        ref={pigRef}
      />
      <CaseNotes fullName={fullName} slug={slug} />
      <AddComment slug={slug} onCommentAdded={handleRefreshComments} />
      <hr className="govuk-section-break govuk-section-break--l govuk-section-break--visible" />
      <CommentList slug={slug} refresh={refreshComments} />
    </div>
  );
};

export default PatientNotes;
